// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiClient } from '../services/api-client.js';
import { useLocale } from '../hooks/useLocale.js';
import { usePageTitle } from '../hooks/usePageTitle.js';

export function VerifyEmailPage() {
  usePageTitle('Verify Email');
  const { t } = useLocale();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setError(t.auth.verify_email.invalid_token);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;

    async function verify() {
      try {
        await apiClient.verifyEmail({ token });
        if (!cancelled) {
          setSuccess(true);
        }
      } catch (err: any) {
        if (!cancelled) {
          setError(err.message || t.auth.verify_email.failed);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    verify();

    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>{t.auth.verify_email.title}</h1>

        {loading && (
          <div>
            <p>{t.auth.verify_email.verifying}</p>
          </div>
        )}

        {success && (
          <div>
            <p className="success-message">{t.auth.verify_email.success}</p>
            <Link to="/login">{t.auth.verify_email.go_to_login}</Link>
          </div>
        )}

        {error && (
          <div>
            <p className="error-message">{error}</p>
            <Link to="/login">{t.auth.verify_email.go_to_login}</Link>
          </div>
        )}
      </div>
    </div>
  );
}
